/* eslint-disable no-continue */
import Timeslots from '../modules/timeslots';

export default class {
    constructor(instance) {
        this.booking = instance;
    }

    get() {
        let numberOfRounds = 0;
        const rounds = [];

        for (let index = 0; index < this.booking.gms.flights.length; index++) {
            const flight = this.booking.gms.flights[index];

            if (flight.claims.length > numberOfRounds) {
                numberOfRounds = flight.claims.length;
            }
        }

        for (let roundIndex = 0; roundIndex < numberOfRounds; roundIndex++) {
            const round = {
                claimed: false,
                claims: [],
            };

            for (let index = 0; index < this.booking.gms.flights.length; index++) {
                const flight = this.booking.gms.flights[index];

                if (flight.claims[roundIndex]) {
                    // Push the claim to the round
                    flight.claims[roundIndex].done = (flight.claims[roundIndex].numberOfHoles == '0');

                    if (!flight.claims[roundIndex].done && flight.claims[roundIndex].hasOwnProperty('times')) {
                        flight.claims[roundIndex].done = (flight.claims[roundIndex].times && flight.claims[roundIndex].times.length == 0 && flight.claims[roundIndex].reservationId);
                    }
                    round.claims.push(flight.claims[roundIndex]);
                }
            }

            const noClaimsOrDone = _.filter(round.claims, (object, index) => !(object.reservationId || object.done));

            const claimsNotDone = _.filter(round.claims, (object, index) => !object.done);

            round.claimed = (noClaimsOrDone.length == 0);
            round.done = (claimsNotDone.length == 0);
            rounds.push(round);
        }

        return rounds;
    }

    add() {
        for (let index = 0; index < this.booking.gms.flights.length; index++) {
            const flight = this.booking.gms.flights[index];

            // Determine startHole for the next round
            const claim = flight.claims[this.booking.activeRound];
            const startHole = (claim.numberOfHoles == '9') ? 10 : 1;

            flight.claims.push({
                selectedDayPart: 'morning',
                times: null,
                startHole,
                numberOfHoles: '9',
                startTime: null,
            });
        }

        // eslint-disable-next-line operator-assignment
        this.booking.activeRound = this.booking.activeRound + 1;

        if (this.booking.activeFlight > 0) {
            this.booking.activeFlight = 0;
            return;
        }

        // Manually check for new times because the activeFlight watcher won't be triggered if the activeFlight already was 0
        this.booking.$api.gms.reservation.findStartTimes(
            this.booking.date,
            this.booking.gms.flights[this.booking.activeFlight],
            this.booking.gms.flights[this.booking.activeFlight].claims[this.booking.activeRound],
            this.booking.gms.visitId,
        ).then((claim) => {
            // eslint-disable-next-line no-param-reassign
            claim.selectedDayPart = Timeslots.getDaypartForFirstAvailableSlot(this.booking.slots, claim.times);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    edit(roundIndex) {
        // Determine how many rounds we have to clear
        this.booking.activeRound = roundIndex;

        // Clear round with index
        for (let index = 0; index < this.booking.gms.flights.length; index++) {
            const flight = this.booking.gms.flights[index];

            for (let claimIndex = 0; claimIndex < flight.claims.length; claimIndex++) {
                const claim = flight.claims[claimIndex];

                if (claimIndex == roundIndex) {
                    continue;
                }

                if (!claim.reservationId) {
                    flight.claims.splice(claimIndex, 1);
                    continue;
                }

                this.booking.$api.gms.reservation.removeClaim(this.booking.gms.visitId, claim.reservationId)
                .then((response) => {
                    flight.claims.splice(claimIndex, 1);
                })
                .catch((error) => {});
            }
        }
    }

    onEditClick(index) {
        this.booking.$modals.$emit('show-modal:edit-round', () => {
            this.edit(index);
        });
    }
}
